import { ref } from 'vue';

const currentBrandColor = ref('#2781F6');

/**
 * Converte HEX para objeto RGB
 */
function hexToRgb(hex) {
  let cleanHex = hex.replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map(c => c + c)
      .join('');
  }
  const num = parseInt(cleanHex, 16);
  return {
    r: (num >> 16) & 255,
    g: (num >> 8) & 255,
    b: num & 255,
  };
}

/**
 * Aplica a cor primária da marca no elemento raiz (:root) via CSS Variables
 * @param {string} hexColor - Cor hexadecimal (ex: #2781F6, #820AD1, #10B981)
 */
export function setBrandColor(hexColor) {
  if (!hexColor || !/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hexColor)) {
    return;
  }

  currentBrandColor.value = hexColor;
  const rgb = hexToRgb(hexColor);
  const root = document.documentElement;

  root.style.setProperty('--brand-color', hexColor);
  root.style.setProperty(
    '--brand-hover-color',
    `color-mix(in srgb, ${hexColor} 88%, black)`
  );
  root.style.setProperty(
    '--brand-active-color',
    `color-mix(in srgb, ${hexColor} 75%, black)`
  );
  root.style.setProperty(
    '--brand-subtle-color',
    `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.12)`
  );
  root.style.setProperty(
    '--brand-border-color',
    `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.3)`
  );
  root.style.setProperty('--brand-text-color', hexColor);
}

/**
 * Inicializa a cor de marca a partir das configurações globais
 */
export function initBrandColor() {
  const config = window.chatwootConfig || {};
  const configuredBrandColor = config.brandColor || config.BRAND_COLOR;
  if (configuredBrandColor) {
    setBrandColor(configuredBrandColor);
  }
}

export function useBrandingTheme() {
  return {
    currentBrandColor,
    setBrandColor,
    initBrandColor,
  };
}
